import React, { useState } from "react";
import allImgPaths from "assets/images";
import StackedBarChart from "../common/charts/StackedBarChart";

const InsightBuddy = () => {
  const [isActive, setIsActive] = useState(0);
  const [isEditable, setIsEditable] = useState(false);

  const visuaalizationChartItem = [
    {
      chartName: "Bar Chart",
      imgPath: allImgPaths.BarChartIcon,
    },
    {
      chartName: "Line Chart",
	  imgPath: allImgPaths.LineChartIcon,
    },
    {
      chartName: "Pie Chart",
	  imgPath: allImgPaths.PieChartIcon,
    },
    {
      chartName: "Activity Gauge",
	  imgPath: allImgPaths.ActivityGuageChartIcon,
    },
    {
      chartName: "List",
	  imgPath: allImgPaths.ListChartIcon,
    },
    {
      chartName: "Table",
	  imgPath: allImgPaths.TableChartIcon,
    },
  ];

  const handleTextEditable = () => {
	setIsEditable(!isEditable);
  }
  return (
    <>
      <div className='flex h-full insight-wrapper'>
        <div className='w-[250px] bg-white border-r border-[#ededed] py-6 px-5'>
          {/* Ask */}
          <p className='text-base font-interMedium text-[#101828] pb-2'>
            Ask Anything
          </p>
          <textarea className='border border-[#EAECF0] rounded py-2 px-2 resize-none mb-6 w-[202px] h-[123px]'></textarea>

          {/* Visualization */}
          <p className='text-base font-interMedium text-[#101828] pb-2'>
            Change visualization
          </p>
          <div className='flex flex-wrap gap-2'>
            {visuaalizationChartItem.length > 0 &&
              visuaalizationChartItem.map((item, index: any) => (
                <div
                  key={index}
                  onClick={() => {
                    setIsActive(index);
                  }}
                  className={`rounded border text-center py-2 bg-white w-[48%] cursor-pointer ${
                    isActive === index ? "border-[#1E0AF5]" : "border-[#EAECF0] "
                  } mb-2 cursor-pointer`}
                >
                  <img
                    className={`${isActive === index ? "svg-icon-blue" : ""} mx-auto mb-1.5 w-4 h-4`}
                    src={item.imgPath}
                    alt='bar chart'
                  />
                  <p className={`${isActive === index ? "text-[#1E0AF5]" : "text-[#344054]"} text-xs font-interMedium`}>
                    {item.chartName}
                  </p>
                </div>
              ))}

          </div>
        </div>
        <div className='w-[calc(100%_-_250px)] px-6 py-6'>
          <p className='text-base font-interMedium text-[#101828] pb-4'>
            Visualization
          </p>
          <div className='flex items-center justify-between w-full px-6'>
            <div>
              <p className='text-sm font-interMedium text-[#667085]'>Title</p>
              <p
                // contentEditable={`${isEditable}`}
                className={`${isEditable ? "border-[#eee] py-0.5 px-2 rounded" : "border-transparent py-0.5 px-0 rounded"} border text-base font-interMedium text-[#101828]`}
              >
                Vendor Communication analysis
              </p>
            </div>
            <img
			onClick={handleTextEditable}
              className='cursor-pointer'
              src={allImgPaths.EditTextIcon}
              alt=''
            />
          </div>
          {
            isActive === 0 && <div className='w-[80%] mx-auto h-[calc(100%_-_150px)] flex items-center justify-center'>
            <StackedBarChart />
          </div>
          }
          
        </div>
      </div>
    </>
  );
};

export default InsightBuddy;
